/** ルート進入前の先回りモーダルの文言: チャットルート */
export const preroutePromptChat = {
  /** 見出しの上の導入（物色・消費直前とも）。相手が待っているかもしれない、と送る理由を添える */
  lead: "待ってるかも？",
  /** 見出し */
  title: (args: { name: string | number }) => `${args.name}さんへ`,
  /** 相手の吹き出し。相手が最後に送ったテキストが無いときだけ出す一言（2026-10-15 ユーザー指定） */
  bubble: "早くしたいな...♡",
  /** CTA 下の注記: 送るのに要るポイント */
  ctaNote: (args: { point: string | number }) => `1通/${args.point}ptが必要`,
  /** 書きかけの見出し（吹き出しの上） */
  draftLabel: "書きかけのメッセージ",
  /** CTA: 書きかけをそのまま送る */
  ctaSendDraft: "このまま送る",
  /** CTA: トークルームを開いて入力欄にフォーカス */
  ctaWrite: "メッセージを送る",
} as const;
